import { useIsUnitAdmin as useSharedIsUnitAdmin, type UseIsUnitAdminResult } from "@scoutingops/security";

import { useSupabaseClient } from "@/hooks/use-supabase-client";

export type { UseIsUnitAdminResult };

/** Thin binding of @scoutingops/security's shared useIsUnitAdmin() to this app's own useSupabaseClient() — same pattern as scoutingops-hub's use-is-unit-admin.ts. */
export function useIsUnitAdmin(): UseIsUnitAdminResult {
  const getSupabase = useSupabaseClient();
  return useSharedIsUnitAdmin(getSupabase);
}
